<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'sample-setproofing',
  components: { PageTable },
}
</script>
